/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_AllInputs */

const en_work_all = /** @type {(inputs: Work_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Works`)
};

const ar_work_all = /** @type {(inputs: Work_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كل الأعمال`)
};

const bn_work_all = /** @type {(inputs: Work_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সব কাজ`)
};

const de_work_all = /** @type {(inputs: Work_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Werke`)
};

const es_work_all = /** @type {(inputs: Work_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los trabajos`)
};

const fr_work_all = /** @type {(inputs: Work_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les travaux`)
};

const pt_work_all = /** @type {(inputs: Work_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os trabalhos`)
};

const zh_work_all = /** @type {(inputs: Work_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有作品`)
};

const tr_work_all = /** @type {(inputs: Work_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm Çalışmalar`)
};

const ru_work_all = /** @type {(inputs: Work_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все работы`)
};

const pl_work_all = /** @type {(inputs: Work_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystko działa`)
};

/**
* | output |
* | --- |
* | "All Works" |
*
* @param {Work_AllInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const work_all = /** @type {((inputs?: Work_AllInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_AllInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_work_all(inputs)
	if (locale === "bn") return bn_work_all(inputs)
	if (locale === "de") return de_work_all(inputs)
	if (locale === "es") return es_work_all(inputs)
	if (locale === "fr") return fr_work_all(inputs)
	if (locale === "pt") return pt_work_all(inputs)
	if (locale === "zh") return zh_work_all(inputs)
	if (locale === "tr") return tr_work_all(inputs)
	if (locale === "ru") return ru_work_all(inputs)
	if (locale === "pl") return pl_work_all(inputs)
	return en_work_all(inputs)
});